<template>
  <thead>
    <tr>
      <th
        v-for="(col, index) in columns"
        :key="col.id"
        :class="{'sortable': col.sortable, 'center': col.center}"
        @click="col.sortable ? colSort(col.id) : null"
        :width="col.width"
      >
        <template v-if="hasFirstCol && index === 0">
          <slot name="firstCol" />
        </template>
        <span v-else>
          {{ col.name }}
          <template v-if="col.sortable">
            <IconSortable v-show="sortBy !== col.id" />
            <IconSortDown v-show="sortBy === col.id && sortDesc === false" />
            <IconSortUp v-show="sortBy === col.id && sortDesc === true" />
          </template>
        </span>
      </th>
    </tr>
  </thead>
</template>

<script setup lang="ts">
import IconSortable from '@/icons/arrows/IconSortable.svg?component';
import IconSortDown from '@/icons/arrows/IconSortDown.svg?component';
import IconSortUp from '@/icons/arrows/IconSortUp.svg?component';

import type { Column } from '@/types/Column';

defineProps<{
  sortBy?: string,
  // sortDesc could theoretically be a number because of the API
  // just ignore it if that happens.
  sortDesc: boolean | number,
  hasFirstCol: boolean,
  columns: Column[]
}>();
const emit = defineEmits(['colSort']);

const colSort = (id: string) => {
  emit('colSort', id);
}

</script>
